import { useState, useEffect } from 'react';

export const useCatalog = (initialData) => {
  const [state, setState] = useState({
    data: [],
    isLoading: true,
    error: null
  });

  useEffect(() => {
    let isMounted = true;

    const loadData = async () => {
      try {
        await new Promise(resolve => setTimeout(resolve, 1500));
        
        if (isMounted) {
          if (!initialData || initialData.length === 0) {
            throw new Error("No inventory found in database.");
          }
          
          setState({
            data: initialData,
            isLoading: false,
            error: null
          });
        }
      } catch (err) {
        if (isMounted) {
          setState({ data: [], isLoading: false, error: err.message });
        }
      }
    };

    loadData();
    return () => { isMounted = false; };
  }, [initialData]);

  return state;
};